export default {
  // baseURL: 'http://ticket-api.hzqykeji.com',
  version: '1.0.1'
}